const translations = {
  'teachingYoungLearners.seo.title':
    'Enseñanza del curso TEFL para jóvenes estudiantes en Barcelona',
  'teachingYoungLearners.seo.description':
    'Aprende a enseñar a niños de 5 a 16 años con nuestro curso práctico para jóvenes. Práctica real de enseñanza y retroalimentación con niños y adolescentes.',
};

export default translations;
